/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon32Regular = forwardRef('TimeClockFastIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16 5C10.234 5 5.503 9.437 5.038 15.082a1 1 0 0 1-1.994-.164C3.595 8.244 9.184 3 16 3c7.18 0 13 5.82 13 13 0 6.815-5.244 12.405-11.918 12.956a1 1 0 1 1-.164-1.994C22.563 26.497 27 21.766 27 16c0-6.075-4.925-11-11-11Z" }),
        React.createElement("path", { d: "M15 8.75a1 1 0 0 1 1 1v5.264a1 1 0 0 0 .553.894l4.394 2.198a1 1 0 1 1-.894 1.788l-4.395-2.197A3 3 0 0 1 14 15.014V9.75a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M3.5 27a1 1 0 1 0 0 2H12a1 1 0 1 0 0-2H3.5Z" }),
        React.createElement("path", { d: "M0 24a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M2.5 19a1 1 0 1 0 0 2H6a1 1 0 1 0 0-2H2.5Z" })));
});
